import { authAxios as axios } from "shared-auth";
import { AsyncAction } from "shared/types/utilities";
import config from "config/global";
import { ActionType } from "store/types";
import { GetUserData, SetUserData } from "store/user/user.types";

import {
  convertPerformerAccessType,
  convertPerformerAgencyList,
} from "store/user/user.helper";
import { IUser } from "shared/models/user";
import { AccountType } from "component-library";

export const AccountTypeMapping = {
  Agent: AccountType.Agent,
  Performer: AccountType.Performer,
  CastingDirector: AccountType.CastingDirector,
};

// ============================== Redux Actions =======================================================================

export const setUserData: SetUserData = (userData) => ({
  type: ActionType.SetUserData,
  payload: userData,
});

export const getUserData: AsyncAction<GetUserData> = () => async (dispatch) => {
  const { data } = await axios(config.whoAmIUrl);

  const performerAccessType = convertPerformerAccessType(
    data.agencyPermissions
  );

  const user: IUser = {
    id: data.userId,
    type: AccountTypeMapping[data.userType],
    email: data.email,
    forenames: data.forenames,
    surname: data.surname,
    restrictAccess: data.restrictAccess,
    performerAccessType,
    agencyList: convertPerformerAgencyList(
      data.agencyPermissions,
      performerAccessType
    ),
  };

  dispatch(setUserData(user));

  return user;
};
